export const queryKeys = {
  SUBSIDIARY_PROBLEMS_VIEW: "subsidiary-problems-view",
  SUBSIDIARY_DETAILED_PROBLEM: "subsidiary-detailed-problem",
  SUBSIDIARY_EMPLOYEES_SELECT: "subsidiary-employees-select",
}